import React from "react"
import { useTranslation } from "react-i18next"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@f2e/ui/components/base"
import { Workspace } from "@/types"

interface WorkspaceSelectProps {
  workspaces: Workspace[]
  defaultValue?: string
  onWorkspaceChange: (workspaceId: string) => void
}

const WorkspaceSelect: React.FC<WorkspaceSelectProps> = ({
  workspaces,
  defaultValue = "all",
  onWorkspaceChange,
}) => {
  const { t } = useTranslation()
  const triggerId = "workspace-select"
  return (
    <div className="mb-4 flex items-center space-x-4">
      <label htmlFor={triggerId} className="font-medium">
        {t("historyList.workspaceSelect.label")}
      </label>
      <Select onValueChange={onWorkspaceChange} defaultValue={defaultValue}>
        <SelectTrigger id={triggerId} className="w-[200px]">
          <SelectValue
            placeholder={t("historyList.workspaceSelect.placeholder")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">
            {t("historyList.workspaceSelect.all")}
          </SelectItem>
          {workspaces.map((workspace) => (
            <SelectItem key={workspace.id} value={workspace.id}>
              {workspace.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default WorkspaceSelect
